import { ApiUser } from 'api/types/ApiUserEnvironment';
import { getJson, postJson } from 'utils/http';

export type Invite = {
  id: string;
  email: string;
  byUser: {
    id: string;
    name: string;
  };
  hooks: Array<{
    hookType: string;
    organization?: {
      id: string;
      name: string;
    };
  }>;
};

export function fetchInvite(inviteId: string): Promise<Invite> {
  return getJson(`/data/website/invites/${inviteId}`).then(
    // @ts-expect-error TS(2345): Argument of type '({ invite }: { invite: any; }) =... Remove this comment to see the full error message
    ({ invite }) => invite,
  );
}

export function acceptInvite(inviteId: string): Promise<ApiUser> {
  // @ts-expect-error TS(2345): Argument of type '({ user }: { user: any; }) => an... Remove this comment to see the full error message
  return postJson(`/data/website/invites/${inviteId}`).then(({ user }) => user);
}
